import worksRoute from './works'
import membersRoute from './members'
import PasswordResetRoute from './password-reset'

const routes = [membersRoute, worksRoute, PasswordResetRoute]

export default routes
